import React from "react";
import { useTranslation } from "react-i18next";
import moment from 'moment';

const Card = ({ data }) => {
    const { t } = useTranslation();
    return (
        <div className='flex flex-col bg-gradient-to-r from-white/95 via-white/98 to-white/95 backdrop-blur-xl rounded-2xl border-2 border-crimson/30 shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden'>
            {/* Card Header with Date */}
            <div className='bg-gradient-to-br from-crimson via-red-primary to-crimson px-4 py-3 relative'>
                <div className="flex justify-between items-center">
                    <span className="text-white font-bold text-sm">Transaction Details</span>
                    <span className="text-white text-xs font-semibold">
                        {moment(new Date(data?.date)).format('DD.MM.YYYY h:mm A')}
                    </span>
                </div>
                {/* Luxury Border Accent at bottom */}
                <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-to-r from-golden via-white to-golden"></div>
            </div>

            {/* Transaction Details */}
            <div className='divide-y divide-crimson/20'>
                <div className='grid grid-cols-2 gap-4 py-3 px-4 hover:bg-crimson/5 transition-colors duration-200'>
                    <h4 className="font-semibold text-blue-primary text-sm">{t("openingBalance")}</h4>
                    <p className="font-myanmarKhay font-bold text-grass text-right">{data?.opening}</p>
                </div>
                <div className='grid grid-cols-2 gap-4 py-3 px-4 hover:bg-crimson/5 transition-colors duration-200'>
                    <h4 className="font-semibold text-blue-primary text-sm">{t("inward")}</h4>
                    <p className="font-myanmarKhay font-bold text-sky text-right">{data?.inward}</p>
                </div>
                <div className='grid grid-cols-2 gap-4 py-3 px-4 hover:bg-crimson/5 transition-colors duration-200'>
                    <h4 className="font-semibold text-blue-primary text-sm">{t("betAmount")}</h4>
                    <p className="font-myanmarKhay font-bold text-golden text-right">{data?.bet}</p>
                </div>
                <div className='grid grid-cols-2 gap-4 py-3 px-4 hover:bg-crimson/5 transition-colors duration-200'>
                    <h4 className="font-semibold text-blue-primary text-sm">{t("profitAmount")}</h4>
                    <p className="font-myanmarKhay font-bold text-grass text-right">{data?.win}</p>
                </div>
                <div className='grid grid-cols-2 gap-4 py-3 px-4 hover:bg-crimson/5 transition-colors duration-200'>
                    <h4 className="font-semibold text-blue-primary text-sm">{t("outward")}</h4>
                    <p className="font-myanmarKhay font-bold text-crimson text-right">{data?.outward}</p>
                </div>
                <div className='grid grid-cols-2 gap-4 py-3 px-4 bg-crimson/5 relative overflow-hidden'>
                    {/* Luxury Border Accent at top */}
                    <div className="absolute top-0 left-0 right-0 h-0.5 bg-gradient-to-r from-crimson via-golden to-crimson"></div>
                    <h4 className="font-bold text-blue-primary">{t("closingBalance")}</h4>
                    <p className="font-myanmarKhay font-bold text-crimson text-right text-lg">{data?.closing}</p>
                </div>
            </div>
        </div>
    );
}

export default Card;
